import React, { useState } from "react";
import css from './Elementsdegrammaire.module.css';

function Elementsdegrammaire() {
  const [active, setActive] = useState('situation-sociolinguistique');

  return (
    <div className={css.page}>
      <div className={css.layout}>
        {/* En-tête style Guide */}
        <header className={css.hero}>
          <div className={css.heroKicker}>Grammaire</div>
          <h1 className={css.heroTitle}>Éléments de grammaire</h1>
          <p className={css.heroSub}>Du kinyarwanda</p>
        </header>

        {/* Corps du contenu dans une carte */}
        {/* Sommaire interne (ancre) similaire à Brève Histoire */}
        
        { /* active tab state for TOC */ }
        <nav className={css.subnav} aria-label="Sommaire du guide">
          <ul>
            <li>
              <button type="button" className={`${css.tab} ${active === 'situation-sociolinguistique' ? css.tabActive : ''}`} onClick={() => {
                setActive('situation-sociolinguistique');
                const el = document.getElementById('situation-sociolinguistique');
                if(el){ const y = el.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top: y, behavior: 'smooth' }); }
              }}>Situation sociolinguistique</button>
            </li>
            <li>
              <button type="button" className={`${css.tab} ${active === 'phonetique-phonologie' ? css.tabActive : ''}`} onClick={() => {
                setActive('phonetique-phonologie');
                const el = document.getElementById('phonetique-phonologie');
                if(el){ const y = el.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top: y, behavior: 'smooth' }); }
              }}>Phonétique et phonologie</button>
            </li>
            <li>
              <button type="button" className={`${css.tab} ${active === 'structure-du-mot' ? css.tabActive : ''}`} onClick={() => {
                setActive('structure-du-mot');
                const el = document.getElementById('structure-du-mot');
                if(el){ const y = el.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top: y, behavior: 'smooth' }); }
              }}>Structure du mot</button>
            </li>
            <li>
              <button type="button" className={`${css.tab} ${active === 'classification-nominale' ? css.tabActive : ''}`} onClick={() => {
                setActive('classification-nominale');
                const el = document.getElementById('classification-nominale');
                if(el){ const y = el.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top: y, behavior: 'smooth' }); }
              }}>Classification nominale</button>
            </li>
            <li>
              <button type="button" className={`${css.tab} ${active === 'categories-grammaticales' ? css.tabActive : ''}`} onClick={() => {
                setActive('categories-grammaticales');
                const el = document.getElementById('categories-grammaticales');
                if(el){ const y = el.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top: y, behavior: 'smooth' }); }
              }}>Catégories grammaticales</button>
            </li>
            <li>
              <button type="button" className={`${css.tab} ${active === 'conclusion' ? css.tabActive : ''}`} onClick={() => {
                setActive('conclusion');
                const el = document.getElementById('conclusion');
                if(el){ const y = el.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top: y, behavior: 'smooth' }); }
              }}>Conclusion</button>
            </li>
          </ul>
        </nav>

        <article className={css.content}>
        
        <h2 id="situation-sociolinguistique">Situation sociolinguistique</h2>
        <p>
          Le kinyarwanda est une langue bantu parlée en Afrique Centrale, au Rwanda et dans les pays environnants. C’est une langue à classes et à tons comme toutes les langues de la même famille. La population rwandaise estimée à peu près à 12 millions d’habitants, dans sa presque totalité (plus de 95%), parle le kinyarwanda.
        </p>
        <p>
          Des langues qui se nomment différemment comme <em>ikirundi</em> parlé au Burundi, <em>ikinyabwishya</em> et <em>ikinyamulenge</em> à l’Est de la République démocratique du Congo, <em>igiha</em> et <em>igishubi</em> au Nord-Ouest de la Tanzanie (près de la frontière du Burundi et du Rwanda), <em>igifumbira</em> au Sud de l’Ouganda, formeraient des dialectes d’une seule et même langue. Elles ont en effet une base lexicale identique à plus de 70%. On peut estimer actuellement à plus de 30 millions la population qui parle ces langues inter-compréhensibles. Ces langues sont situées dans ce que les linguistes appellent la zone J ou la zone inter-lacustre.
        </p>
        <p>
          Les chaines de radio internationales comme la BBC et la Voix de l’Amérique diffusent quotidiennement des programmes en kinyarwanda-kirundi sans que cela pose un problème aux auditeurs.
        </p>
        <p>
          Sur le territoire national, le kinyarwanda parlé est presque uniforme sauf de minimes différences régionales qui ne nuisent pas à l’intercompréhension. Ces différences sont remarquables par une différence d’intonation et la prononciation de certains phonèmes ainsi que de légères différences syntaxiques pour le kinyarwanda parlé dans le Nord (<em>Amajyaruguru</em>), ou pour le kinyarwanda parlé par les membres de l’ethnie <em>Abatwa</em>. Il existe aussi des parlers caractéristiques à certaines pratiques religieuses traditionnelles, notamment <em>urukonjo</em> parlé par les adeptes du culte de Ryangombe et celui parlé par les adeptes de Nyabingi, qui ont, à leur manière, enrichi le lexique du kinyarwanda.
        </p>

        <h2 id="phonetique-phonologie">Phonétique et phonologie</h2>
        <p>Le kinyarwanda dispose d’un alphabet de 24 signes :</p>
        <ul>
          <li><strong>5 voyelles :</strong> i [i] comme dans « vie » ; u [u] comme dans « doux » ; e [e] comme dans « thé » ; o [o] comme dans « dos » ; a [a] comme dans « pas ».</li>
          <li><strong>19 consonnes :</strong> b, c, d, f, g, h, j, k, l, m, n, p, r, s, t, v, w, y, z.</li>
        </ul>
        <p>
          Deux consonnes se prononcent de la même façon : l et r. Il n’y a effectivement aucune différence au niveau phonologique, c’est l’orthographe, qui, depuis l’avènement de l’écriture du kinyarwanda (vers 1900), qui établit cette différence. Dans l’orthographe actuelle la lettre « l » reste dans les noms de personnes et les noms de lieux, partout ailleurs c’est la lettre « r » qui s’impose.
        </p>

        <h3>Tableau des consonnes</h3>
        <div className={css.tableWrapper}>
          <table className={css.table}>
            <thead>
              <tr>
                <th className={css.th}>Lettre</th>
                <th className={css.th}>Phonétique</th>
                <th className={css.th}>Exemple</th>
                <th className={css.th}>Traduction</th>
              </tr>
            </thead>
            <tbody>
              <tr><td className={css.td}>b</td><td className={css.td}>[ʋ]</td><td className={css.td}>ibaba</td><td className={css.td}>(aile)</td></tr>
              <tr><td className={css.td}></td><td className={css.td}>[b]</td><td className={css.td}>imbunda</td><td className={css.td}>fusil</td></tr>
              <tr><td className={css.td}>c</td><td className={css.td}>[tʃ]</td><td className={css.td}>icumu</td><td className={css.td}>lance</td></tr>
              <tr><td className={css.td}>d</td><td className={css.td}>[d]</td><td className={css.td}>urudodo</td><td className={css.td}>fil</td></tr>
              <tr><td className={css.td}></td><td className={css.td}>[ɖ]</td><td className={css.td}>indoro</td><td className={css.td}>regard</td></tr>
              <tr><td className={css.td}>f</td><td className={css.td}>[f]</td><td className={css.td}>ifi</td><td className={css.td}>poisson</td></tr>
              <tr><td className={css.td}>g</td><td className={css.td}>[g]</td><td className={css.td}>umugani</td><td className={css.td}>conte</td></tr>
              <tr><td className={css.td}></td><td className={css.td}>[gj]</td><td className={css.td}>umugina</td><td className={css.td}>termitière</td></tr>
              <tr><td className={css.td}>h</td><td className={css.td}>[h]</td><td className={css.td}>umuheha</td><td className={css.td}>chalumeau</td></tr>
              <tr><td className={css.td}>j</td><td className={css.td}>[ j ]</td><td className={css.td}>ijisho</td><td className={css.td}>œil</td></tr>
              <tr><td className={css.td}>k</td><td className={css.td}>[k]</td><td className={css.td}>ikamba</td><td className={css.td}>couronne</td></tr>
              <tr><td className={css.td}></td><td className={css.td}>[kj]</td><td className={css.td}>ikibindi</td><td className={css.td}>cruche</td></tr>
              <tr><td className={css.td}>l</td><td className={css.td}>[ɾ]</td><td className={css.td}>Kigali</td><td className={css.td}>(Toponyme)</td></tr>
              <tr><td className={css.td}>m</td><td className={css.td}>[m]</td><td className={css.td}>imana</td><td className={css.td}>dieu</td></tr>
              <tr><td className={css.td}>n</td><td className={css.td}>[n]</td><td className={css.td}>ino</td><td className={css.td}>orteil</td></tr>
              <tr><td className={css.td}>p</td><td className={css.td}>[p]</td><td className={css.td}>urupapuro</td><td className={css.td}>papier</td></tr>
              <tr><td className={css.td}>r</td><td className={css.td}>[ɾ]</td><td className={css.td}>kurima</td><td className={css.td}>creuser</td></tr>
              <tr><td className={css.td}>s</td><td className={css.td}>[s]</td><td className={css.td}>isoko</td><td className={css.td}>source</td></tr>
              <tr><td className={css.td}>t</td><td className={css.td}>[t]</td><td className={css.td}>itama</td><td className={css.td}>joue</td></tr>
              <tr><td className={css.td}></td><td className={css.td}>[ʈ]</td><td className={css.td}>intama</td><td className={css.td}>mouton</td></tr>
              <tr><td className={css.td}>v</td><td className={css.td}>[v]</td><td className={css.td}>kuvuna</td><td className={css.td}>casser</td></tr>
              <tr><td className={css.td}>w</td><td className={css.td}>[w]</td><td className={css.td}>iwacu</td><td className={css.td}>chez nous</td></tr>
              <tr><td className={css.td}>y</td><td className={css.td}>[j]</td><td className={css.td}>yagiye</td><td className={css.td}>il est parti</td></tr>
              <tr><td className={css.td}>z</td><td className={css.td}>[z]</td><td className={css.td}>izuba</td><td className={css.td}>soleil</td></tr>
            </tbody>
          </table>
        </div>

        <h3>Syllabes : consonnes complexes</h3>
        <p>Voici les combinaisons consonantiques possibles :</p>
        <ul>
          <li>bg [bg], bw [bg], by [bgj], byw [bgjw], mb [ɱb], mbw [ɱbg], mby [ɱbgj], mbyw [ɱbgjw]</li>
          <li>cw [ʧkw], cy [kj], nc [ŋʧ], ncw [ŋʧkw], ncy [ŋkj]</li>
          <li>dw [dgw], nd [ŋɖ], ndw [ŋɖw], ndy [ŋɖj]</li>
          <li>fw [fk], mf [ɱf], mfw [ɱfk]</li>
          <li>gw [gw], ng [ŋg], ngw [ŋgw]</li>
          <li>hw [hw]</li>
          <li>jw [ʒɡw], jy [gj], nj [ŋʒ], njw [ŋʒgw], njy [ŋgy]</li>
          <li>kw [kw], nk [ŋk], nkw [ŋkw]</li>
          <li>mw [ɱw], my [mɲ], myw [mɲw]</li>
          <li>nw [nŋw], ny [ɲ], nyw [ɲw]</li>
          <li>pf [pf], pfw [pfk], pw [pk], py [pky], mp [ɱp], mpw [ɱpk], mpy [ɱpkj]</li>
          <li>rw [ɾgw], ry [ɾgj]</li>
          <li>sw [skw], sy [skj], ns [ŋts], nsy [ŋtskj], nsw [ŋtskw]</li>
          <li>sh [ʃ], shw [ʃkw], shy [ʃʼ], shyw [ʃʼkw], nsh [ŋʃ], nshw [ŋʃkw], nshy [ŋʃʼ]</li>
          <li>tw [tkw], ty [tj], nt [ŋʈ], ntw [ŋʈw], nty [ŋʈj]</li>
          <li>vw [vg], vy [vj], mv [ɱv], mvw [ɱvg], mvyw [ɱvjw]</li>
          <li>zw [zgw], nz [ŋz], nzw [ŋzgw]</li>
        </ul>

        <h3>Tons et longueurs vocaliques</h3>
        <p>Le kinyarwanda est une langue à tons et à longueurs de voyelles :</p>
        <p><strong>Pour les tons</strong>, on distingue un ton bas (non marqué) et un ton haut marqué par un accent aigu :<br />
        Ex : <em>igikara</em> « couleur noire » / <em>igikára</em> « braise »</p>
        <p><strong>Pour les longueurs vocaliques</strong>, on oppose des voyelles brèves (à une seule more) et les voyelles longues (à deux mores) :<br />
        <em>Gukata</em> « couper » / <em>gukaata</em> « piétiner »</p>
        <p>Ces signes prosodiques ne sont pas notés en orthographe ordinaire, ils ne sont utilisés que pour les analyses scientifiques. Leur indication est indispensable en lexicographie, c’est la raison pour laquelle dans ce dictionnaire, chaque entrée écrite en alphabet ordinaire, est suivie de sa notation phonologique.</p>

        <h2 id="structure-du-mot">Structure du mot</h2>
        <p>Le mot du kinyarwanda se forme autour d’une base lexicale qu’on appelle racine, radical ou thème auquel s’agglutinent préfixes et suffixes qui servent à le grammaticaliser et fixer le sens de la base lexicale.</p>
        
        <div className={css.example}>
          Umugabo « homme » / Kugaba « conduire une attaque »<br />
          Umugaba « commandant » / Kugabura « donner à manger »<br />
          Ingabo « soldat, bouclier » / Kugabira « donner à »<br />
          Ingabe « tambour royal » / Kugabana « partager »<br />
          Ikigabiro « résidence du roi » / Kugabanya « diviser »<br />
          Nzagaba igitero « je mènerai une attaque »
        </div>

        <p>Voici la morphologie de trois mots donnés en exemple ci-dessus :</p>
        <div className={css.example}>
          <ul>
            <li><code>|u-mu+gab-o|</code> : augment – classificateur +racine – terminaison</li>
            <li><code>|ku-ø+gab-a|</code> : classificateur – morphème temporel +racine – terminaison</li>
            <li><code>|n-zaa+gab-a|</code> : 1ère personne sg – morphème temporel +racine – terminaison</li>
          </ul>
        </div>

        <h2 id="classification-nominale">La classification nominale en kinyarwanda</h2>
        <p>La classe nominale est indiquée par un préfixe dénommé classificateur qui précède la base lexicale. En discriminant le nombre en son sein, la classe exprime une catégorisation plus ou moins indéterminée d’êtres ou d’objets. Comme toutes les langues bantu, le kinyarwanda est une langue à classes par opposition aux langues indo-européennes qui ont adopté le genre. Le kinyarwanda possède 11 classes chacune associant le singulier à son pluriel.</p>

        <div className={css.diagram}>
          UNIVERS<br />
          NTU<br />
          CONTENU (Indéterminé) : IBINTU (Êtres de l’Univers)<br />
          CONTENANT (Déterminé) : AHANTU (Espace-Temps)<br />
          <br />
          Sous-divisions de IBINTU :<br />
          Déterminé : UMUNTU (humain)<br />
          Indéterminé : IBINTU (non-humain)
        </div>

        <h3>Tableau des classes</h3>
        <div className={css.tableWrapper}>
          <table className={css.table}>
            <thead>
              <tr>
                <th className={css.th}>Classe</th> 
                <th className={css.th}>Augment (Sing/Plur)</th> 
                <th className={css.th}>Préfixe Singulier</th> 
                <th className={css.th}>Préfixe Pluriel</th>
              </tr>
            </thead>
            <tbody>
              <tr><td className={css.td}>1</td> <td className={css.td}>u-/a-</td> <td className={css.td}>-mu-</td> <td className={css.td}>-ba-</td></tr>
              <tr><td className={css.td}>2</td> <td className={css.td}>u-/i-</td> <td className={css.td}>-mu-</td> <td className={css.td}>-mi-</td></tr>
              <tr><td className={css.td}>3</td> <td className={css.td}>i-/a-</td> <td className={css.td}>-ri-</td> <td className={css.td}>-ma-</td></tr>
              <tr><td className={css.td}>4</td> <td className={css.td}>i-/a-</td> <td className={css.td}>-ø-</td> <td className={css.td}>-ma-</td></tr>
              <tr><td className={css.td}>5</td> <td className={css.td}>u-/a-</td> <td className={css.td}>-ku-</td> <td className={css.td}>-ma-</td></tr>
              <tr><td className={css.td}>6</td> <td className={css.td}>i-/i-</td> <td className={css.td}>-n-</td> <td className={css.td}>-n-</td></tr>
              <tr><td className={css.td}>7</td> <td className={css.td}>i-/i-</td> <td className={css.td}>-ki-</td> <td className={css.td}>-bi-</td></tr>
              <tr><td className={css.td}>8</td> <td className={css.td}>u-/i-</td> <td className={css.td}>-ru-</td> <td className={css.td}>-bi-/-n-</td></tr>
              <tr><td className={css.td}>9</td> <td className={css.td}>u-</td> <td className={css.td}>-bu-</td> <td className={css.td}>-ma-</td></tr>
              <tr><td className={css.td}>10</td> <td className={css.td}>a-/u-</td> <td className={css.td}>-ka-</td> <td className={css.td}>-tu-/-bu-</td></tr>
              <tr><td className={css.td}>11</td> <td className={css.td}>a-</td> <td className={css.td}>-ha-</td> <td className={css.td}>(locatif)</td></tr>
            </tbody>
          </table>
        </div>

        <h3>Classificateurs à valeur qualificative</h3>
        <p>L’univers se répartit en contenant (espace-temps) et contenu (êtres et objets) : en effet toutes les autres classes à l’exception de la classe locative (classe 11), peuvent s’accorder au pluriel de la classe 7, surtout lorsque le sujet est collectif. C’est à ce niveau que le contenant est déterminé. Le pluriel de la classe 7 « collectif » qui regroupe la catégorie IBINTU se subdivise, au niveau du langage, en séparant la catégorie de l’humain UMUNTU qui devient ainsi déterminée, des autres classes à contenu plus ou moins indéterminé.</p>
        <p>Il y a aussi des mots à contenu expressif qui ne comportent pas de classificateur comme les interjections et les idéophones, ainsi que des mots à contenu identifiable qui, eux, s’accordent forcément dans une classe donnée sans avoir de classificateur (souvent des mots d’emprunts comme <em>ari</em> « are », <em>kaki</em>, qui sont regroupés automatiquement à la 4ème classe dont le classificateur n’est pas représenté formellement -ø-).</p>
        <p>Les adverbes non plus n’ont pas de classificateur, même si parfois on peut deviner à partir de leur étymologie qu’ils en ont mais que leur contenu a été neutralisé. En effet leur place syntaxique dans la phrase ne leur permet pas de s’accorder.</p>
        
        <p>Les noms de personnes ou les noms de lieux peuvent également comporter des classificateurs, mais leur signification première est neutralisée afin qu’ils s’accordent uniquement en première classe pour les noms de personnes et en 11ème classe pour les toponymes.</p>
        
        <div className={css.example}>
          Exemple : <em>Ku Kibuye hahuha umuyaga uturuka mu Kivu</em><br />
          « À Kibuye il souffle un vent qui provient du lac Kivu »<br />
          La classe 7 -ki- du mot Kibuye a été neutralisée, c’est la classe 11 -ha- qui opère dans le verbe. Le toponyme Kibuye provient du mot « ikibuye » « grosse pierre » qui, lui, s’accorde à la 7ème classe.
        </div>
        
        <p>La neutralisation est une règle générale qui souffre de quelques exceptions souvent poétiques. Exemple : <em>Gisenyi cy’abadasenya</em>. "Gisenyi de ceux qui ne détruisent jamais". Le mot Gisenyi garde dans ce cas-ci son accord en classe 7 dans le connectif <code>|-ki-a-|</code> <em>cya</em>, qui est élidé (cy’) devant un mot qui commence par une voyelle.</p>

        <p>Parmi les classes à contenu plus ou moins indéterminé, certaines pourront servir à l’usage expressif avec des valeurs qualifiantes péjoratives ou mélioratives « petit, minuscule » (classes 9 et 10) ou « grand, gros » (classes 7 et 8) même si fondamentalement elles servent comme toutes les autres à la catégorisation :</p>
        
        <div className={css.example}>
          Umugabo « homme »<br />
          ikigabo « gros homme » (cl.7) / urugabo « gros bonhomme » (cl.8)<br />
          akagabo « petit homme » (cl.10) / ubugabo « petits bonhommes » (cl.9)
        </div>

        <p>À part les deux classes de l’humain et celle de l’espace-temps que l’on peut définir, les autres classes sont indéterminées. L’humain est au centre de l’univers : seuls l’humain et l’univers sont déterminés, distincts ; les autres êtres ou objets sont indéterminés, et sont classés indistinctement dans plusieurs autres classes (2 à 10) auxquelles on ne pourra pas donner de définition précise. Le contenu d’une classe est variable et n’appartient pas forcément à une catégorie déterminée d’êtres.</p>
        <p>Le rôle du classificateur sera d’assurer les accords au niveau de la phrase, il se retrouve en effet dans le nom, dans l’adjectif, dans le pronom. Exemple : <em>A ka ka gabo ga to ka rakarishye ntimu ka gaye umubyimba</em> (Ce petit bonhomme est autoritaire ne le mésestimez pas à cause de sa taille).</p>

        <h2 id="categories-grammaticales">Les catégories grammaticales et leur morphologie</h2>
        <p>Les mots du kinyarwanda se répartissent en substantifs, verbes, adjectifs, pronoms, adverbes et interjections.</p>

        <h3>5.1. Le substantif : augment – classificateur + thème lexical</h3>
        <p>En plus du thème lexical, le substantif comprend un classificateur et un augment. L’augment est une particule (voyelle) qui fonctionne par présence ou absence, généralement par opposition de la généralisation et de la particularisation. Cette dernière est toujours introduite généralement par un élément contextuel qui rétrécit (pronom) ou refuse (négateur) l’extensivité. Cette extensivité peut être réduite également par un élément de l’ordre de l’expressivité comme l’interpellation.</p>
        
        <div className={css.example}>
          <em>Umwana</em> « enfant » (généralisation)<br />
          <em>uyu mwana</em> « cet enfant » (particularisation : l’augment tombe devant le pronom)<br />
          <em>nta mwana nabonye</em> « je n’ai pas vu d’enfant » (négation : l’augment tombe aussi devant le négateur)<br />
          <em>Yewe mwana</em> « Hé toi petit »
        </div>
        <p>L’augment est toujours identique à la voyelle du classificateur qu’elle préfigure. L’absence de l’augment occasionne la présence d’un autre élément particularisant. La fonction de l’augment en plus de celui du classificateur sert à contextualiser ce qui est évoqué par le substantif.</p>

        <h3>5.2. L’adjectif : classificateur + thème lexical</h3>
        <p>Le classificateur de l’adjectif correspond à celui du nom auquel il se rapporte. Exemple : <em>Umugabo munini</em> (Un gros bonhomme), <em>igiti kinini</em> (un grand arbre).</p>
        <p>Il s’agit ici de la forme canonique de l’adjectif qui ne compte que quelques thèmes lexicaux :</p>
        <ul>
          <li>|+bí| « mauvais », |+kurú| « grand, ancien »</li>
          <li>|+bísi| « cru », |+níiyá| ou |+núuru| « petit »</li>
          <li>|+éeru| « blanc », |+níni| « grand »</li>
          <li>|+garí| « large », |+re| « long »</li>
          <li>|+gufí| ou |+gufíiyá| « petit », |+sa| « seul »</li>
          <li>|+hiíre| « heureux », |+shyá| « neuf, nouveau »</li>
          <li>|+iínshi| « beaucoup », |+siíndi| « sain »</li>
          <li>|+iíra| « tard », |+taraga| « sauf, vivant »</li>
          <li>|+iizá| « beau », |+tóoyá| ou |tó| « petit »</li>
          <li>|+ké| « peu », |+zima| « vivant »</li>
        </ul>
        <p>Les autres notions que l’on penserait adjectivales sont formalisées sur la structure substantivale (ex: couleurs comme <em>Umutuku</em> "rouge"). Pour exprimer une notion qualificative, la langue procède par adjectivation via la particule connective (<em>Umwenda w’umukara</em> « vêtement noir ») ou par un relatif (<em>Umwenda wirabura</em> « un vêtement qui est noir »).</p>

        <h3>5.3. Le pronom</h3>
        <p>Selon qu’il complète le nom ou le supplée, le pronom est construit à l’exemple de l’adjectif, ou à l’exemple du substantif. S’il s’agit d’un pronom personnel, alors il intégrera dans sa morphologie les distinctions entre personnes comme dans un verbe.</p>
        
        <div className={css.example}>
          <strong>Complétif :</strong> Classificateur+thème : uno |u+nó| « celui-ci même » ; uyu |u+yu| « celui-ci » ; uwo |u+wo| « celui-là même » ; uriya |u+ríiya| « celui-là » ; urya |u+ryá| « l’autre-là » ; wa |u+áa| « l’autre-là ».<br />
          <strong>Supplétif :</strong> augment-classificateur+thème : undi |u+ndi| « l’autre », abandi |a-ba+ndi| « les autres ».<br />
          <strong>Personnel :</strong> njye (moi), wowe (toi), we (lui), twe (nous), mwe (vous), bo (eux).
        </div>
        <p>Le pronom sert soit à remplacer le substantif, soit à placer dans l’espace-temps ce qui est évoqué par le substantif. Voici comment s’organise l’espace-temps :</p>
        
        <div className={css.tableWrapper}>
          <table className={css.table}>
            <thead>
              <tr>
                <th colSpan="2" className={css.th}>MOI (Contextuel - Près de moi)</th>
                <th colSpan="3" className={css.th}>HORS-MOI (Contextuel - Éloigné)</th>
                <th className={css.th}>HORS-MOI (Mémoriel - Ailleurs)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={css.td}>Celui-ci même</td> <td className={css.td}>Celui-ci</td> <td className={css.td}>Celui-là même</td> <td className={css.td}>Celui-là</td> <td className={css.td}>L'autre-là</td> <td className={css.td}>L'autre</td>
              </tr>
              <tr>
                <td className={css.td}>Uno</td> <td className={css.td}>Uyu</td> <td className={css.td}>Uwo</td> <td className={css.td}>Uriya</td> <td className={css.td}>Urya / Wa</td> <td className={css.td}>Undi</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3>5.4. Les adverbes ou « modaux »</h3>
        <p>La forme de l’adverbe est beaucoup plus monolithique et invariable. Exemples : <em>Ubwenge buke cyane</em> « très peu d’intelligence », <em>Gira vuba</em> « fais vite ».</p>

        <h3>5.5. Les particules</h3>
        <ul>
          <li><strong>Le Connectif :</strong> Il existe sous trois formes (association, comparaison, attribution).
            <ul>
              <li>Attributif (|classificateur+a|) : <em>Umwenda w’umutuku</em> « un vêtement rouge ».</li>
              <li>Associatif « na » et comparatif « nka » (invariables) : <em>Isake n’inkokokazi</em> « le coq et la poule ».</li>
            </ul>
          </li>
          <li><strong>Négateur nominal « nta » :</strong> Devant le nom ou le verbe en relative. <em>Nta muntu nahabonye</em> « je n’y ai vu personne ».</li>
          <li><strong>Conjonction et mots de transition :</strong> Mots figés comme <em>ariko</em> « mais », <em>cyokora</em> « de toute façon », <em>nubwo</em> « même si ».</li>
        </ul>

        <h3>5.6. Le verbe</h3>
        
        <h4>5.6.1. La structure du verbe</h4>
        <p>Il existe deux structures : l’infinitif (qui peut indiquer le présent <em>Kugura</em> et le futur <em>Kuzagura</em>) et le verbe conjugué (<code>|personne-morphème temporel+racine-marque aspectuelle|</code>).</p>
        
        <div className={css.example}>
          Yaguze : |a-a+gur-ye| (elle a acheté)<br />
          Yaguriye : |a-a+gur-ir-ye| (elle a acheté pour)<br />
          Yamuguriye : |a-a-mu+gur-ir-ye| (elle lui a acheté)<br />
          Yawumuguriye : |a-a-wu-mu+gur-ir-ye| (elle le lui a acheté)<br />
          Yawuhamuguriye : |a-aa-wu-ha-mu+gur-ir-ye| (elle le lui a acheté là-bas)
        </div>
        <p>Il existe aussi un complément réfléchi exprimé par le réflexif |-íiy-| : <em>Kwigurira umwenda</em> « s’acheter un habit ».</p>

        <h4>5.6.2. La conjugaison du verbe</h4>
        <p><strong>La personne :</strong> Représentée par le pronom personnel (Naguze, Waguze, Yaguze, Twaguze, Mwaguze, Baguze).</p>
        <p><strong>Le temps verbal :</strong> Le kinyarwanda dispose de 5 temps. Le temps est structuré sur l’opposition <em>none</em> (aujourd'hui) / <em>ejo</em> (hier ou demain).</p>
        <ul>
          <li><strong>Le présent :</strong> Distingue l’habituel (sans marque : <em>Aboha</em>) et l’instant de parole (morphème |-ra-| : <em>Araboha</em>).</li>
          <li><strong>Le passé :</strong> Distingue le passé proche (|-a-| : <em>baboshye</em> uyu munsi) et le passé lointain (|-á-| : <em>baboshye</em> ejo).</li>
          <li><strong>Le futur :</strong> Distingue le futur immédiat (|-ra-|) et le futur lointain (|-zaa-| : <em>Azaboha</em>).</li>
        </ul>

        <div className={css.diagram}>
          EJO (hier) — NONE (aujourd’hui / instant parole) — EJO (demain)<br />
          ∞ ----------------------------------------------------------------------- ∞<br />
          passé lointain ... passé proche ... [nonaha] ... futur proche ... futur lointain
        </div>

        <h4>La modalité</h4>
        <p>On distingue le niveau <strong>thétique</strong> (indicatif, exprime le temps) et le niveau <strong>hypothétique</strong> (infinitif, potentiel, optatif, impératif).</p>
        <ul>
          <li><strong>Potentiel (|-aa-|) :</strong> <em>Nagenda</em> « je partirais ».</li>
          <li><strong>Optatif :</strong> Simple (<em>Agende</em> « qu'il parte ») ou Supplicatif (<em>Uragende</em> « pars je t'en prie »).</li>
          <li><strong>Impératif :</strong> 2ème pers. sg. sans marque de temps/personne (<em>Genda</em> « vas t'en »).</li>
        </ul>

        <h4>La diathèse verbale</h4>
        <ul>
          <li><strong>Proversive (|-i-|) :</strong> Orientée du sujet actif au complément.
            <ul>
              <li>Causatif (|-i-|) : <em>Kuvuza</em> « faire résonner ».</li>
              <li>Factitif (|-ish-|) : <em>Kuvugisha</em> « faire résonner au moyen de ».</li>
              <li>Facilitatif (|-ik-|) : <em>Ivugitse</em> « bien tournée ».</li>
              <li>Attributif (|-ir-|) : <em>Kurira</em> « manger à cause de », <em>Arandikira</em> « il écrit à ».</li>
            </ul>
          </li>
          <li><strong>Réversive (|-u-|) :</strong> Renverse le sens ou inverse la relation.
            <ul>
              <li>Passif (|-u-|) : <em>Gukubitwa</em> « être frappé ».</li>
              <li>Suffixe |-ur-| : <em>Yahaguye</em> « a détaché ».</li>
              <li>Suffixe |-uk-| : <em>Wahagutse</em> « est détaché ».</li>
            </ul>
          </li>
          <li><strong>Stative (|-a-|) :</strong> Relation neutre. <em>Guhagama</em> « être coincé », <em>Guhagarara</em> « être debout ».</li>
        </ul>

        <h4>L’aspect</h4>
        <p><strong>Aspect simple (Terminaison du verbe) :</strong></p>
        <ul>
          <li>Endotopique (|-a|) : Procès en déroulement. <em>Ndakora</em> « je travaille ». Passé en déroulement : |-aga| (<em>navugaga</em>).</li>
          <li>Exotopique (|-e| / |-ye|) : Extériorité. <em>Tugende</em> (avant), <em>Ndavuze</em> (après/accompli).</li>
        </ul>
        
        <p><strong>Aspect relatif (Mise en relation) :</strong></p>
        <ul>
          <li>Inchoatif (|-ráa-|) : Début du procès. <em>Sindakora</em> « je n’ai pas encore travaillé ».</li>
          <li>Continuatif (|-kí-|) : Entre début et fin. <em>Aracyavuga</em> « il parle encore ».</li>
          <li>Subsécutif (|-ka-|) : Successivité. <em>Akavuga</em> « et il fait ».</li>
          <li>Sémelfactif (|-na-|) : Simultanéité. <em>Baravuga banasakuza</em> « Ils parlent en criant ».</li>
        </ul>

        <h3>5.7. Les verbes défectifs</h3>
        <p>Ils n’ont pas d’infinitif et fonctionnent en binôme avec des verbes qui en ont : kugira / |+fite| « avoir », kuba / |+ri| « être », kubona / |+ruuzi|, kumenya / |+ :zi| « savoir ».</p>

        <h3>5.8. Les « coverbes » ou « déictiques verbaux »</h3>
        <p>Ne se conjuguent qu’au présent : |+ti| (<em>Agira ati</em> « il dit »), |+te| (<em>Agira ate ?</em> « il fait comment ? »), |+ti-a| (<em>Agira atya</em> « il fait comme ceci »), |+ti-o| (<em>Agira atyo</em> « il fait comme cela »).</p>

        <h2 id="conclusion">Conclusion</h2>
        <p>Ce sont là les parties du discours dont la structure régit la syntaxe du kinyarwanda. Nous n’allons pas nous étendre sur cette partie de la grammaire en espérant que les éléments morphologiques fournis permettront au lecteur d’appréhender les divers sens des entrées de ce dictionnaire.</p>
        
        <div className={css.author}>Eugène Shimamungu</div>
      </article>
      </div>
    </div>
  );
}

export default Elementsdegrammaire;